import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../lib/theme';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      className="p-1.5 rounded hover:bg-surface3-light dark:hover:bg-surface3-dark text-ink-muted_l dark:text-ink-muted_d"
      title={theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
    </button>
  );
}
